<script lang="ts">
  import { router } from '@inertiajs/svelte';
  import { signOutModalOpen, closeSignOutModal } from '../lib/stores/ui';
  import { useModalAnimation } from '../lib/useModalAnimation.svelte';

  const modal = useModalAnimation(() => $signOutModalOpen, closeSignOutModal);

  function handleSignOut() {
    closeSignOutModal();
    router.delete('/session');
  }

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      modal.animateClose();
    }
  }
</script>

<svelte:window onkeydown={$signOutModalOpen ? handleKeydown : undefined} />

{#if $signOutModalOpen}
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div
    class="modal-overlay"
    class:closing={modal.closing}
    bind:this={modal.overlayEl}
    onclick={modal.animateClose}
    role="presentation"
  >
    <div class="modal-card" onclick={(e) => e.stopPropagation()} role="dialog" tabindex="-1">
      <!-- Header -->
      <div class="border-b border-gray-200 px-5 py-4">
        <h2 class="text-lg font-semibold text-gray-900">Sign out</h2>
      </div>

      <!-- Body -->
      <div class="px-5 py-4">
        <p class="text-sm text-gray-600">Are you sure you want to sign out?</p>
      </div>

      <!-- Actions -->
      <div class="flex justify-end gap-3 border-t border-gray-200 px-5 py-4">
        <button
          type="button"
          class="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
          onclick={modal.animateClose}
        >
          Cancel
        </button>
        <button
          type="button"
          class="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700"
          onclick={handleSignOut}
        >
          Sign out
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    animation: overlay-in 150ms ease-out both;
  }

  .modal-overlay.closing {
    animation: overlay-out 100ms ease-in both;
  }

  .modal-overlay.closing .modal-card {
    animation: card-out 100ms ease-in both;
  }

  .modal-card {
    background: white;
    border-radius: 0.75rem;
    box-shadow:
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 8px 10px -6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 24rem;
    margin: 0 1rem;
    overflow: hidden;
    animation: card-in 150ms cubic-bezier(0.16, 1, 0.3, 1) both;
  }

  @keyframes overlay-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes overlay-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes card-in {
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes card-out {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(0.95);
      opacity: 0;
    }
  }
</style>
